<owl-carousel-o [options]="customOptions" class="reviews-slider">
    @for (comment of commentItems; track comment) {
    <ng-template [id]="comment.title" carouselSlide>
        <div class="grid md:grid-cols-[auto_1fr] gap-10 md:gap-16 text-ayr-white items-start">
            <div class="max-w-[137px] justify-self-center">
                <img class="h-full object-contain rounded-full w-24 lg:w-32 m-auto" [src]="comment.companyImage"
                    [alt]="comment.alt" loading="lazy" />
            </div>
            <div>
                <b class="italic">{{comment.title}} </b>
                <span class="italic">"{{comment.comment}}"</span>

                <div class="pl-8" *ngIf="comment.commentSpanNumber">
                    <span class="non-bold d-block">
                        <ul class="leading-8">
                            @for (quote of comment.commentSpanNumber; track quote) {
                            <li style="
                                    font-weight: initial;
                                    font-size: clamp(0.8rem, 1.25vw, 1.25rem) !important;
                                  ">
                                <span class="text-bold text-ayr-green-500 description">
                                    {{ quote.value }}
                                </span>
                                {{ quote.description }}
                            </li>
                            }

                        </ul>
                    </span>
                </div>

                <div class="mt-3">
                    <p class="text-21 lg:text-27 text-ayr-green-500 font-bold">{{comment.author}}</p>
                    <p class="text-13 font-semibold">{{comment.authorRole | translate}}</p>
                </div>
            </div>
        </div>

    </ng-template>
    }
</owl-carousel-o>